import React, { useEffect, useContext, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '../../../Button/PlainButtonOrLink';
import VisuallyHidden from '../../../a11y/VisuallyHidden';
import useMediaQuery from '../../../utils/hooks/useMediaQuery';
import Context from '../../common/Utils/Context';
import { mergeStyles } from '../../common/Utils/mergeStyles';
import { validate } from '../../common/Utils/data-schema-validator';
import schema from './data-schema.json';
import giphyStyles from './giphy-viewer.scss';
var GiphyViewer = function (_a) {
    var componentData = _a.componentData;
    var theme = useContext(Context.type).theme;
    var t = useTranslation().t;
    var _b = useState(false), isGifPaused = _b[0], setIsGifPaused = _b[1];
    var handleMediaQueryUpdate = useCallback(function (doesPreferReducedMotion) { return setIsGifPaused(doesPreferReducedMotion); }, [setIsGifPaused]);
    useMediaQuery('(prefers-reduced-motion: reduce)', handleMediaQueryUpdate);
    useEffect(function () {
        validate(componentData, schema);
    }, [componentData]);
    var styles = giphyStyles || mergeStyles({ styles: giphyStyles, theme: theme });
    return (React.createElement("div", { className: styles['root'] },
        React.createElement("img", { className: styles['giphy_player'], src: isGifPaused
                ? componentData.gif.stillUrl
                : componentData.gif.originalUrl, alt: "gif" }),
        React.createElement(PlainButtonOrLink, { className: styles['control'], onClick: function () { return setIsGifPaused(!isGifPaused); } },
            React.createElement(VisuallyHidden, null, isGifPaused
                ? t('chat.message.gifEnable')
                : t('chat.message.gifDisable')))));
};
GiphyViewer.displayName = 'GiphyViewer';
export default GiphyViewer;
//# sourceMappingURL=giphy-viewer.js.map